import http from '../../service/index'
import postJson from "@/service/postJson"
/**
 *
根据店铺编码获取所属小区：scm/planShopApply/getOrgListByShopId
分页查看店铺有效商品：scm/planShopApply/qryShopItemPage
新增或修改商品活动数量申请单：scm/planShopApply/savePlanShopApply
管理后台分页查询申请单：scm/planShopApply/list
app分页查询申请单：scm/planShopApply/qryplanShopApplyForApp
审核商品活动数量申请单：scm/planShopApply/checkPlanShopApply
 */

export const planShopApplyGetOrgListByShopId = (params) => http.get('/scm/planShopApply/getOrgListByShopId', { params })
export const planShopApplyQryShopItemPage = (params) => http.get('/scm/planShopApplyDetail/qryShopItemPage', { params })



/**
 * 添加/修改数据
 * //#region 请求参数
 *
 * agentId          : '',   // 代理商编码true*
 * itemId           : '',   // 商品编码true*
 * orgId            : '',   // 归属小区true*
 * planDate         : '',   // 补货日期(yyyy-mm-dd)true*
 * planNums         : '',   // 申请数量true*
 * shopId           : '',   // 归属店铺true*
 * skuId            : '',   // SKU编码true*
 * voList           : '',   // voListtrue*
 * agentId          : '',   // 代理商编码false*
 * itemId           : '',   // 商品编码false*
 * orgId            : '',   // 归属小区false*
 * planApplyId      : '',   // 申请编码false*
 * planDate         : '',   // 补货日期false*
 * planNums         : '',   // 申请数量false*
 * shopId           : '',   // 归属店铺false*
 * skuId            : '',   // SKU编码false*
 * planApplyId      : '',   // 采购申请编码false*
 * //#endregion
 * //#region 响应参数
 * -
 * //#endregion
 *
 */
// export const planShopApplySavePlanShopApply = (data) => http.post('/scm/planShopApply/savePlanShopApply', data, { raw: true })

export const planShopApplySavePlanShopApply = (data) => {
 return postJson({
  url: '/scm/planShopApply/savePlanShopApply',
  method: 'post',
  data,
  headers:{'Content-Type': 'application/json' }
 })
}


/**
 * 批量审核申请单
 * //#region 请求参数
 *
 * planApplyIds     : '',   // 采购申请编码,多个逗号分隔false*
 * state            : '',   // 审核状态 1-审核通过 2-审核失败false*
 * //#endregion
 * //#region 响应参数
 * -
 * //#endregion
 *
 */
export const planShopApplyCheckPlanShopApply = (data) => http.post('/scm/planShopApply/checkPlanShopApply', data)
/**
 * 根据当前登陆人获取管理小区
 * //#region 请求参数
 * -
 * //#endregion
 * //#region 响应参数
 *
 * orgId            : '',   // 小区编码
 * orgName          : '',   // 小区名称
 * //#endregion
 *
 */
 export const getOrgListByPassId = (data) => http.get('/scm/planShopApplyDetail/getOrgListByPassId', data)

 /**
 * app获取分页数据
 *
 */
export const qryplanShopApplyForApp = (data) => http.get('/scm/planShopApply/qryplanShopApplyForApp', data)




export const listPlanShopApply = (data) => http.get('scm/planShopApply/list', data)


export const getByIdPlanShopApply = (params) => http.get('/scm/planShopApply/getById', { params })

export const submitPlanShopApply = (data) => {
 return postJson({
  url: '/scm/planShopApply/submit',
  method: 'post',
  data,
  headers:{'Content-Type': 'application/json' }
 })
}

//查询仓库
export const listStockWarehouse = (params) => {
 return http({
  url: 'scm/stockWarehouse/list',
  params,
  method: 'get'
 })
}
//查询库区

export const listStockReservoirArea = (params) => {
 return http({
  url: 'scm/stockReservoirArea/list',
  params,
  method: 'get'
 })
}
//查询货架
export const listStockGoodsShelves = (params) => {
 return http({
  url: 'scm/stockGoodsShelves/list',
  params,
  method: 'get'
 })
}

//查询库位
export const listStockCargoSpace = (params) => {
 return http({
  url: 'scm/stockCargoSpace/list',
  params,
  method: 'get'
 })
}
//查询库位库存
export const listStockCargoSpaceNums = (params) => {
 return http({
  url: 'scm/wareBitStock/list',
  params,
  method: 'get'
 })
}

export const getBitStockListBySkuId = (params) => {
 return http({
  url: 'scm/wareBitStock/getBitStockListBySkuId',
  params,
  method: 'get'
 })
}



export const qryStockBitPageList = (params) => {
 return http({
  url: 'scm/wareBitStock/qryStockBitPageList',
  params,
  method: 'get'
 })
}
export const getPlanOrgProdList = (params) => {
 return http({
  url: 'scm/planShopApplyDetail/getPlanOrgProdList',
  params,
  method: 'get'
 })
}



//库位库存上架
export const placeStock = (data) => {
 return postJson({
  url: '/scm/wareBitStock/placeStock',
  method: 'post',
  data,
  headers:{'Content-Type': 'application/json' }
 })
}

//库位库存下架
export const downStock = (data) => {
 return postJson({
  url: '/scm/wareBitStock/downStock',
  method: 'post',
  data,
  headers:{'Content-Type': 'application/json' }
 })
}

export const batDownStock = (data) => {
 return postJson({
  url: '/scm/wareBitStock/batDownStock',
  method: 'post',
  data,
  headers:{'Content-Type': 'application/json' }
 })
}

//撤销申请
export const cancelPlanShopApply = (params) => {
    return http({
        url: 'scm/planShopApply/cancel',
        params,
        method: 'get'
    })
}


export const verifyPlanShopApply = (data) => {
    return postJson({
        url: '/scm/planShopApply/verify',
        method: 'post',
        data,
        headers:{'Content-Type': 'application/json' }
    })
}



export const getUnSortPlanOrg = (params) => {
 return http({
  url: 'scm/planOrg/getUnSortPlanOrg',
  params,
  method: 'get'
 })
}

//库位库存移库
export const moveStock = (data) => {
 return postJson({
  url: '/scm/wareBitStock/moveStock',
  method: 'post',
  data,
  headers:{'Content-Type': 'application/json' }
 })
}

export const getSortingList = (params) => {
 return http({
  url: 'scm/planOrg/getSortingList',
  params,
  method: 'get'
 })
}





// WEBPACK FOOTER //
// ./src/api/scm/planShopApply.js